import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { BoxLoader } from './common/box-loader';
import { CollapsibleSummaryLoader } from './common/collapsible-summary-loader';
import { TotalCountSectionLoader } from './common/total-count-section-loader';

export const RefundsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader />
      <BoxLoader columnsCount={4} shouldRightAlignLastCol />
      <CollapsibleSummaryLoader rowsCount={4} />
      <br />
      <br />
      <TableLoader hideSearchBar hideFilters hideActions columnsCount={6} />
      <br />
      <TotalCountSectionLoader />
      <br />
    </div>
  );
};
